// src/firebase/firestore.js
// دوال عامة (CRUD) تستخدمها أي صفحة مع أي collection في Firestore

import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  onSnapshot,
  query,
  orderBy,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from './config';

export const subscribeToCollection = (collectionName, callback, sortField = 'createdAt') => {
  const q = query(collection(db, collectionName), orderBy(sortField, 'desc'));
  return onSnapshot(
    q,
    (snapshot) => {
      const items = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      callback(items, null);
    },
    (error) => {
      callback([], error);
    }
  );
};

export const addItem = (collectionName, data) => {
  return addDoc(collection(db, collectionName), {
    ...data,
    createdAt: serverTimestamp(),
  });
};

export const updateItem = (collectionName, id, data) => {
  return updateDoc(doc(db, collectionName, id), data);
};

export const deleteItem = (collectionName, id) => {
  return deleteDoc(doc(db, collectionName, id));
};
